import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./About.css";
import dog from "./about.png";
import toast, { Toaster } from "react-hot-toast";
import { useLanguage } from "../../context/LanguageContext";
import { getT } from "../../translations";

gsap.registerPlugin(ScrollTrigger);

function About() {
  const sectionRef = useRef(null);
  const cardRef = useRef(null);
  const headerRef = useRef(null);
  const textRef = useRef(null);
  const imgRef = useRef(null);
  const { lang } = useLanguage();
  const t = getT(lang);
  const walletAddress = "FQN4yCNYgZ2hjJKeUzeYzewvSxNVTUBnosECeqh7pump";

  useEffect(() => {
    const section = sectionRef.current;
    const card = cardRef.current;
    const header = headerRef.current;
    const text = textRef.current;
    const img = imgRef.current;
    if (!section || !card) return;

    gsap.set(card, { opacity: 0, scale: 0.96, y: 24 });
    gsap.set([header, text, img], { opacity: 0, y: 28 });
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 78%",
        toggleActions: "play none none none",
      },
    });
    tl.to(card, { opacity: 1, scale: 1, y: 0, duration: 0.5, ease: "power2.out" })
      .to(header, { opacity: 1, y: 0, duration: 0.4, ease: "power2.out" }, "-=0.2")
      .to(text, { opacity: 1, y: 0, duration: 0.4, stagger: 0.08 }, "-=0.2")
      .to(img, { opacity: 1, y: 0, duration: 0.5, ease: "back.out(1.2)" }, "-=0.3");

    return () => ScrollTrigger.getAll().forEach((t) => t.kill());
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(walletAddress);
    toast.success(t("nav.copied"), {
      duration: 3000,
      position: "top-center",
      style: {
        background: "#b1282a",
        color: "#fff",
        fontWeight: "bold",
        borderRadius: "8px",
        padding: "10px 16px",
        border: "2px solid #000",
      },
    });
  };

  return (
    <section id="about" className="about-section" ref={sectionRef}>
      <div ref={cardRef} className="about-card">
        <div ref={headerRef} className="about-header">{t("about.title")}</div>
        <div className="about-content">
          <div ref={textRef} className="about-text">
            <br/>
            <p>
             {t("about.paragraph1")} {t("about.paragraph2")}
            </p>
            <p className="cap">FQN4yCNYgZ2hjJKeUzeYzewvSxNVTUBnosECeqh7pump</p>

            <button className="about-button" onClick={handleCopy}>
              {t("about.copyContract")}
            </button>
          </div>

          <div className="about-image">
            <img ref={imgRef} src={dog} alt="About dog" />
          </div>
        </div>
      </div>

      {/* Toast container */}
      <Toaster />
    </section>
  );
}

export default About;
